export const routePaths = {
  HOME: '/',
  CONTACT_EXISTING: '/contact/existing',
  CONTACT_TYPES: '/contact/types',
  CONTACT_MYSELF: '/contact/new-myself',
  CONTACT_SOMEONE_ELSE: '/contact/new-someone-else',
  CONTACT_BUSINESS_CHARITY: '/contact/new-business-charity',
  REVIEW_URL: '/payment/review',
  PAY_URL: '/payment/pay'
};
